import { useRef } from 'react'
import { Kbd } from './glyphs'
import { setQuery, useSearch } from './search'

/** The top-bar search: / to focus, type to search every account, ↵ opens the top result, ↓ or esc back to the list. */
export function SearchBox({ onOpenFirst, onFocusList }: { onOpenFirst: () => void; onFocusList: () => void }) {
  const { query, loading } = useSearch()
  const input = useRef<HTMLInputElement>(null)
  return (
    <label className={`search${query ? ' active' : ''}`}>
      <svg className={`search-icon${loading ? ' busy' : ''}`} width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7" /><path d="M20 20l-3.5-3.5" /></svg>
      <input ref={input} className="search-input" value={query} placeholder="Search all mail" spellCheck={false} autoComplete="off" aria-label="Search all mail"
        onChange={event => setQuery(event.target.value)}
        onKeyDown={event => {
          event.stopPropagation()
          if (event.key === 'Escape') { event.preventDefault(); if (query) setQuery(''); else input.current?.blur() }
          else if (event.key === 'Enter') { event.preventDefault(); input.current?.blur(); onOpenFirst() }
          else if (event.key === 'ArrowDown' || event.key === 'Tab') { event.preventDefault(); input.current?.blur(); onFocusList() }
        }} />
      {query ? <button type="button" className="search-clear" tabIndex={-1} onMouseDown={event => event.preventDefault()} onClick={() => { setQuery(''); input.current?.focus() }} aria-label="Clear search">×</button> : <Kbd k="/" />}
    </label>
  )
}
